module.exports = __webpack_public_path__ + "41939f76faca343302c1e575dfd5f1fc.MP3";